import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import PropTypes from "prop-types";
import React, { useState } from "react";

const ConfirmationDialog = ({
  cancelClick,
  okClick,
  confirmText,
  closeDialog,
  buttonText = "Ok",
}) => {
  const [open, setOpen] = useState(true);
  const [value, setValue] = useState("Dione");

  const ConfirmationDialogRaw = (props) => {
    const { onClose, ...other } = props;

    const handleCancel = () => {
      cancelClick(true);
      okClick(false);
      closeDialog(true);
      onClose();
    };

    const handleOk = () => {
      okClick(true);
      cancelClick(false);
      closeDialog(true);
      onClose(value);
    };

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xs"
        aria-labelledby="confirmation-dialog-title"
        open={open}
        {...other}
      >
        <DialogTitle id="confirmation-dialog-title">Confirm</DialogTitle>
        <DialogContent>{confirmText}</DialogContent>
        <DialogActions>
          <Button onClick={handleOk} color="primary">
            {buttonText}
          </Button>
          <Button autoFocus onClick={handleCancel} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  ConfirmationDialogRaw.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired,
  };

  const handleClose = (newValue) => {
    setOpen(false);
    closeDialog(true);
    if (newValue) {
      setValue(newValue);
    }
  };

  return (
    <div>
      <ConfirmationDialogRaw
        id="confirm-popup"
        keepMounted
        open={open}
        onClose={handleClose}
        value={value}
      />
    </div>
  );
};

export default ConfirmationDialog;
